import { filter } from 'es-toolkit/compat';
import { action, computed, makeObservable, observable } from 'mobx';
import { Notification, NotificationLocation, NotificationLocationCode, NotificationType } from '../models';

export class NotificationStore {
  @observable notificationsMap: Map<NotificationLocationCode, Notification[]> = new Map();

  @observable notificationTypes: NotificationType[] = [];

  @observable notificationLocations: NotificationLocation[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  setNotifications(locationCode: NotificationLocationCode, notifications: Notification[]): void {
    this.notificationsMap.clear();
    this.notificationsMap.set(locationCode, notifications);
  }

  @action
  setNotificationTypes(types: NotificationType[]): void {
    this.notificationTypes = types;
  }

  @action
  setNotificationLocations(locations: NotificationLocation[]): void {
    this.notificationLocations = locations;
  }

  @computed
  get nonSuccessNotificationTypes(): NotificationType[] {
    return filter(this.notificationTypes, (type) => type.typeCode !== 'success');
  }

  @computed
  get dashboardPageNotifications() {
    return (locationCode: NotificationLocationCode): Notification[] => {
      return this.notificationsMap.get(locationCode)?.filter((notification) => notification.typeCode !== 'success') ?? [];
    };
  }
}
